const SensoresCard = ({ value }) => {

  return (
    <>
      <th scope="row">{value.idNodo}</th>
      <td>{value.lat}</td>
      <td>{value.lon}</td>
      <td>{value.temperatura}</td>
      <td>{value.calidad}</td>
      <td>{value.humedad}</td>
      <td>{value.presion}</td>
      <td>{value.velocidad}</td>
      <td>{value.direccion}</td>
      <td>{value.precipitaciones}</td>
      <td>{value.intensidad}</td>
      <td>{value.fecha}</td>
      <td>{value.hora}</td>
    </>
  )

}

export default SensoresCard